import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Image from '../../Image'
import Drawer from '../../Drawer'
import Typography from '../../Typography'
import Hr from '../../Hr'
import { Link } from 'react-router-dom'
import useClosable from '../../../hooks/useClosable'
import cn from 'classnames'
import menu from '../../../assets/nav/menu.png'
import close_white from '../../../assets/nav/close_white.png'
import camera from '../../../assets/nav/camera.png'
import portfolio from '../../../assets/nav/portfolio.png'
import yearbook from '../../../assets/nav/yearbook.png'
import appt from '../../../assets/nav/appt.png'
import school_resources from '../../../assets/nav/school_resources.png'
import contact_us from '../../../assets/nav/contact_us.png'
import admin_login from '../../../assets/nav/admin_login.png'
import download from '../../../assets/nav/download.png'
import padlock from '../../../assets/nav/padlock.png'
import pending from '../../../assets/nav/pending.png'
import styles from './Menu.module.sass'
import routes from '../../../routes'

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://shoobphoto.com/'

const getCurrentDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('shoob.cloud')) {
    return 'https://www.shoob.cloud';
  } else {
    return 'https://www.shoobphoto.com';
  }
}

const loggedIn = document.querySelector('#current-user')

const items = [
  { icon: camera, text: 'Purchase Pictures', location: '/' },
  { icon: yearbook, text: 'Purchase Yearbook', location: '/', iconClasses: styles.yearbook },
  { icon: appt, text: 'Book an Appointment', location: routes.scheduleAppointment() },
  { icon: school_resources, text: 'Resources for Schools', location: `${baseUrl}/school_resources`, iconClasses: styles.schoolResources, external: true },
  { icon: pending, text: 'Order Status', location: `/order-status` },
  { icon: padlock, text: 'Get Access Code', location: `/get-access-code` },
  { icon: download, text: 'Download Image', location: `/download-image` },
]

const contactUs = (getCurrentDomain() === 'https://www.shoob.cloud') ?
  { icon: contact_us, text: 'Contact Us', location: `https://www.shoobphotosouth.com/contact1`, external: true } :
  { icon: contact_us, text: 'Contact Us', location: `/contacts/new`, external: true };

items.splice(4, 0, contactUs);

if (loggedIn) items.unshift({ icon: portfolio, text: 'Jobs', location: `${baseUrl}/djobs?type=confirms`, external: true })

const MenuItem = ({ item: { icon, location, text, iconClasses, external = false } }) => {
  if (external) return (
    <a href={location} className={styles.item}>
      <Image src={icon} classes={cn(styles.img, iconClasses)} />
      <Typography classes={styles.text}>{text}</Typography>
    </a>
  )

  return (
    <Link to={location} className={styles.item}>
      <Image src={icon} classes={cn(styles.img, iconClasses)} />
      <Typography classes={styles.text}>{text}</Typography>
    </Link>
  )
}

MenuItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    location: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    iconClasses: PropTypes.string,
    external: PropTypes.bool,
  }).isRequired,
}

const Menu = () => {
  const ref = useRef(null)
  const [open, toggle] = useClosable(ref)

  return (
    <div ref={ref} className={styles.container}>
      <div onClick={toggle} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
        <Image src={menu} classes={styles.iconLeft} />
        <div style={{ marginTop: '4px' }}>
          <Typography tag="span" style={{ color: '#3883c0' }}>Menu</Typography>
        </div>
      </div>
      <Drawer open={open}>
        <div className={styles.itemsWrapper}>
          <Image src={close_white} onClick={toggle} classes={styles.closeIcon} />
          {items.map((item) => <MenuItem item={item} key={item.text} />)}
          <Hr classes={styles.divider} />
          <a href={`${baseUrl}/users/sign_in`} className={styles.adminLoginContainer}>
            <Image src={admin_login} classes={styles.adminImg} />
            <Typography weight="bold" align='center'>School Admin/ Teacher Login</Typography>
          </a>
          <a href={`${baseUrl}/users/sign_in`} className={styles.employeeLogin}>Shoob Employee Login</a>
        </div>
      </Drawer>
    </div>
  )
}

export default Menu
